import React, { useState } from "react";

function PianoRemovalFAQs() {
  const [openAccordionIndex, setOpenAccordionIndex] = useState(null);

  const toggleAccordion = (index) => {
    // Toggle the current accordion's open state
    setOpenAccordionIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const accordionItems = [
    {
      title: "How does your piano removal process work?",
      content: `
 Get a Free Quote: Contact us for an on-site estimate based on your piano’s size and location.
 Schedule Your Removal: Choose a convenient time—we offer same-day and next-day service.
 We Do the Heavy Lifting: Our expert team removes the piano safely and efficiently.
 Eco-Friendly Disposal: We donate or recycle pianos whenever possible.
      `,
    },
    {
      title: "Do you offer eco-friendly disposal?",
      content: `
      Yes! We work with local charities and recycling centers to give pianos a second life or dispose of them responsibly.

      `,
    },
    {
      title: "What areas do you serve?",
      content: `
       We proudly provide local piano removal services in the Metro area and surrounding service area, including:

             Campbell,Los Altos,Fremont,Palo Alto,Saratoga,East Palo Alto,Cupertino,Los Gatos,Mountain View,San Jose,Milpitas,Newark,Santa Clara,Sunnyvale

      `,
    },

    {
      title: "Can I donate my piano instead of disposing of it?",
      content: `
        Absolutely! We work with nonprofit organizations and retirement homes to donate pianos in good condition.
  
        `,
    },
    {
      title: "What happens to a piano after removal?",
      content: `
        Depending on its condition, we either donate, recycle, or dispose of it in an eco-friendly manner.
  
        `,
    },
    {
      title: "How can I book piano removal with Junk Droid?",
      content: `
        You can Book Online or call/text us for an Instant Quote and free estimate!
  
        `,
    },
  ];

  return (
    <div>
      <main>
        <div className="accordion">
          {accordionItems.map((item, index) => (
            <div className="accordion-item" key={index}>
              <div
                className="accordion-item-header"
                onClick={() => toggleAccordion(index)}
                style={{ cursor: "pointer" }}
              >
                <span className="accordion-item-header-title">
                  {item.title}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  class="bi bi-chevron-down"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </div>
              <div
                className="accordion-item-description-wrapper"
                style={{
                  display: openAccordionIndex === index ? "block" : "none",
                }}
              >
                <div className="accordion-item-description furniture-faq">
                  <hr />
                  <p>{item.content}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}

export default PianoRemovalFAQs;
